import styled from 'styled-components';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';


const ProjectWrapper = styled.div`
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;
  margin: 10px;
  display: flex;
  flex: 1 1 300px;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  font-family: "Quicksand", sans-serif;

  &:hover {
    transform: translateY(-3px);
  }

  &:nth-child(1):hover {
    box-shadow: 0px 0px 30px #D45F5F;
  }

  &:nth-child(2):hover {
    box-shadow: 0px 0px 20px darkorange;
  }

  &:nth-child(3):hover {
    box-shadow: 0px 0px 20px darkgreen;
  }

  &:nth-child(4):hover {
    box-shadow: 0px 0px 20px darkblue;

  }
`;

const LinksWrapper = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: space-around;
    width:100%;
`

const ProjectImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 20px;
`;

const ProjectTitle = styled.h2`
  font-size: 30px;
  margin: 10px 0;
  color: rgb(0,0,0,.8)
`;

const ProjectDescription = styled.p`
  font-size: 16px;
  color: #555;
  margin: 10px 0;
  font-family:quicksand;
`;

const ProjectLink = styled.a`
  text-decoration: none;
  font-color:black;
  font-size: 15px;
  margin-top: 10px;
  outline: none;

  &:hover {
    text-decoration:underline;

  }
  &:visited {
    color:black;
    }
  svg {
    margin-left: 5px;
  }
`;

const SourceCodeLink = styled.a`
  text-decoration: none;
  font-size: 15px;
  margin-top: 10px;
  outline:none;
  &:hover {
    text-decoration:underline;
  }
    &:visited {
    color:black;
    }
  svg {
    margin-left: 5px;
  }
`;


const PortfolioProject = ({ title, image, description, link, sourceCode }) => {
    return (
        <ProjectWrapper>
            <ProjectTitle>{title}</ProjectTitle>
            <ProjectImage src={image} alt={`${title} screenshot`} />
            <ProjectDescription>{description}</ProjectDescription>
            <LinksWrapper>
                {link && (
                    <ProjectLink href={link} target="_blank" rel="noopener noreferrer">
                        Live Demo
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </ProjectLink>
                )}

                <SourceCodeLink href={sourceCode} target="_blank" rel="noopener noreferrer">
                    Source Code
                    <FontAwesomeIcon icon={faGithub} />
                </SourceCodeLink>
            </LinksWrapper>

        </ProjectWrapper>
    );
};

export default PortfolioProject;